export const ASSETS_CONSTANTS = {
  DEUNA_LOGO: 'assets/images/deuna_banner_logo.png',
  PAYVALIDA_CASH_PAYMENT_INSTRUCTIONS: 'assets/images/logo_payvalida_cash_payment_instructions.png',
  ALERT_ICON :'assets/images/alerticon_cash_payment_instructions.png',
  PUNTOS_COLOMBIA_LOGO: 'assets/images/ptos_colombia_logo.png',
  YAPE_APP_QR: 'assets/images/yapeAppQr.jpg'
}
